export const BoardType = {
  ACTIVITY: "activity",
  BUSINESS: "business",
};
